import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../../App';
import { useSelector } from 'react-redux';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import CustomCard from '../../reports/summery/detais_new/details_new';
import useQueryGraves from '../../../database/filters/queriesGrave';
import useQueries from '../../../database/useQueries';
import ColumnOrderingGrid from '../../template/table';
import { onClickRow, mapFieldValues, fixNullValues } from '../plagins/utility';
import { useEffect } from 'react';
import { useState } from 'react';
import ConfirmationDialog from '../plagins/dialogs/ConfirmationDialog';
import { createFetchDataServer, createFetchDataServerWithCallback, getTableData } from '../../../database/fetchData';

const BlockDetail = () => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTablePlots.data);
  const properties = useSelector((state) => state.columnsPropertiesBlocks.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);
  // const fetchDataServerWithCallback = createFetchDataServerWithCallback(context);


  // טעינת היוזים לפונקציות עזר
  const { getSummaryByPlot } = useQueryGraves();
  const { getEntitiesByAttr, getEntityByAttr, removeAreaGrave, removePlot, removeBlock } = useQueries();

  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, breadcrumbs, setTitle } = useContext(GlobalContext);

  const [loading, setLoading] = useState(true); // מצב טעינה
  const [rowsPerPage, setRowsPerPage] = useState(25); // מספר רשומות להצגה בעמוד
  const [currentPage, setCurrentPage] = useState(1); // עמוד נוכחי

  // ערכי הראוטר
  const navigate = useNavigate();
  const location = useLocation();
  const { value, summaries } = location.state || {};
  const [myBlock, setMyBlock] = useState(context?.contextBlocks?.find(block => block?.unicId === value?.unicId) || value);
  useEffect(() => {
    setMyBlock(context?.contextBlocks?.find(block => block?.unicId === value?.unicId) || value)
  }, [context?.contextBlocks]);



  useEffect(() => {
    setTotalWidthContainer(1400);
    setTitle(`גוש ${myBlock?.blockNameHe}`);

    const pathSegments = location.pathname.split('/').filter(Boolean); // חילוץ המקטעים מה-URL

    // ביצוע פעולות על פי המקטעים
    if (pathSegments.length > 0) {
      const subSegments = pathSegments.slice(1); // לדוגמה, ['4', '3', '2']

      let temp = breadcrumbs;
      // שמירת האיברים הראשונים עד לאורך של subSegments
      temp = temp.slice(0, subSegments.length);
      temp = [
        ...temp,
        {
          id: (temp.length > 0 ? temp[temp.length - 1].id : 0) + 1,
          name: myBlock?.blockNameHe,
          url: location.pathname,
          state: location.state
        }
      ];

      setBreadcrumbs(temp);
    }
  }, [loading, location.pathname]);

  // סטייט לפופאפ האישור
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleButtonUpdate = () => {
    navigate('/blockUpdate', { state: { value: myBlock } });
  };

  const mappedData = mapFieldValues(context?.contextPlots?.filter(plot => plot?.blockId === myBlock?.unicId), optionsFields);

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };

  // כאשר המשתמש עונה בדיאלוג
  const handleAnswer = (answer) => {
    setOpenConfirmDialog(false);
    if (answer) {
      // כאן מבצעים את פעולת המחיקה
      // const block = getEntityByAttr(localBlocks, 'unicId', value?.unicId);
      // const plots = getEntitiesByAttr(localPlots, 'blockId', block?.unicId)
      // const areaGraves = localAreaGraves.filter(areaGrave =>
      //   plots.some(plot => plot?.unicId === areaGrave.plotId)
      // );

      // areaGraves.forEach(item => { removeAreaGrave({ id: item?.unicId }) });
      // plots.forEach(item => { removePlot({ id: item?.unicId }) });
      removeBlock({ id: myBlock?.id });
      navigate(-1);
    }
  };

  // הסרת אחוזת קבר
  const deleteItem = () => {
    // const block = getEntityByAttr(localBlocks, 'unicId', value?.unicId);
    const plots = getEntitiesByAttr(context?.contextPlots, 'blockId', myBlock?.unicId);
    // const areaGraves = localAreaGraves.filter(areaGrave =>
    //   plots.some(plot => plot?.unicId === areaGrave.plotId)
    // );
    // const graves = localGraves.filter(grave =>
    //   areaGraves.some(areaGrave => areaGrave.gravesList.includes(grave.areaGraveId))
    // );

    let checkEntity = plots;
    // graves.forEach(grave => {
    //   let temp = getEntityByAttr(localBurials, 'graveId', grave?.unicId) ||
    //     getEntityByAttr(localPurchases, 'graveId', grave?.unicId) || null
    //   if (temp !== null) {
    //     checkEntity = [...checkEntity, temp]
    //   }
    // });
    if (checkEntity?.length > 0) {
      alert('לא ניתן להסיר, קיים תיק מקושר');
    } else {
      handleOpenConfirmDialog(); // פותח את הדיאלוג לאישור המחיקה
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks')   
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots')   
        if (dataBlocks && dataPlots) {
          setLoading(false);
        }
      }
      else {
        const handlePartialUpdate = (tableName) => {
          setLoading(false);
        };
        // fetchDataServerWithCallback(['blocks'], token, handlePartialUpdate);
  
        fetchDataServer(['plots'], token);
      }
    }
    loadTableData();
  }, []);

  return (
    <>
      <CustomCard data={properties} value={myBlock} summaries={summaries} handleEdit={handleButtonUpdate} handleDelete={deleteItem} />
      <ColumnOrderingGrid 
      // rows={mappedData} 
      rows={fixNullValues(mappedData)} 
      columns={columns.filter((prop) => prop.show)} searchText={searchText} onRowSelect={(row) => onClickRow(row, getSummaryByPlot, navigate)} />

      {/* דיאלוג לאישור מחיקה */}
      <ConfirmationDialog open={openConfirmDialog} title="אישור מחיקה" content="האם את/ה בטוח שברצונך להסיר את הגוש?" onAnswer={handleAnswer} />
    </>
  );
};

export default BlockDetail;
